var User = /** @class */ (function () {
    function User() {
    }
    User.isUser = function (x) {
        return !!x && typeof x.sei === 'string' && typeof x.mei === 'string' && x.roles instanceof Array;
    };
    return User;
}());
export { User };
//# sourceMappingURL=user.js.map